import { Component } from 'react'
import { connect } from 'react-redux'
import { NavLink, withRouter, Link } from 'react-router-dom'
import { routes } from '../../../v2/routers/router.config'
import { withTranslation } from 'react-i18next'
import { Button } from '../../../iba-components/Button'
import { Avatar } from '../../../iba-components/Avatar'
import { Switch } from '../../../iba-components/Switch'
import { Tooltip } from '../../../iba-components/Tooltip'

import { HOME_URL } from './constant'
import { logout } from '../../api/common'
import './header.css'
import { updateUser } from '../../actions/userInfo'
import { clearFilter } from '../../actions/filterInfo'
import { clearSimulationFilter } from '../../actions/simulationFilterInfo'
import { bindActionCreators } from 'redux'
import LoadingMask from '../LoadingMask'
import { LanguageSelect } from '../LanguageSelect'
import i18next from 'i18next'
import { growV2State } from '../../../v2/utils/startModal'
import { HelpMenu } from '../../../v2/components/HelpMenu'
import styles from './index.module.css'
class Head extends Component {
    constructor() {
        super()
        this.state = {
            loading: false
        }
    }

    get menuList() {
        const { t } = this.props
        const routesList = routes(t)
        const contract = this.props.contract

        switch (contract) {
            case '0':
                return routesList.filter((cfg) => cfg.isBasicRoute)
            case '1':
                return routesList.filter((cfg) => cfg.isAdvancedRoute)
            case '2':
                return routesList.filter((cfg) => cfg.isManagedRoute)
            default:
                return routesList.filter((cfg) => cfg.isAdminRoute)
        }
    }

    LogoutTooltip() {
        return (
            <div className={styles.logout_tooltip}>
                <span>
                    {this.props.t('common.welcome')} {this.props?.userInfo?.username}
                </span>
                <div className={styles.logout_button_area}>
                    <Button
                        className={styles.logout_button}
                        width="110px"
                        label={this.props.t('common.signOut')}
                        onClick={this.signOut}
                    />
                </div>
            </div>
        )
    }

    signOut = async () => {
        this.setState({ loading: true })
        // no update flag
        // When the userinfo in the store is updated, the route page(route.jsx) will update and redirect to the loginiam page(current is logoutapi --(redirect)--> openam --(redirect)--> loginiam)
        // This flag is used to avoid this action
        window.sessionStorage.setItem('notUpdate', true)
        this.props.updateUser({})
        window.sessionStorage.setItem('notUpdate', true)
        this.props.clearFilter()
        window.sessionStorage.setItem('notUpdate', true)
        this.props.clearSimulationFilter()

        const redirect_uri = window.location.origin + '/loginiam'
        const { logout_url } = await logout({ redirect_uri })
        const url = logout_url ? decodeURIComponent(logout_url) : redirect_uri
        window.location.href = url
    }

    handleClickToV2 = () => {
        setTimeout(() => {
            this.props.history.push(`/v2/chooseCmp?languageCode=${i18next.getLang()}`)
            growV2State()
        }, 500)
    }

    render() {
        const { t } = this.props
        const user = this.props?.userInfo?.username
        const avatarLabel = user ? user.slice(0, 1) : 'P'
        return (
            <>
                {this.state.loading && <LoadingMask />}
                <div className="secondary-header-container a-apply-dark-theme-color">
                    <nav className={`a-header-wrapper justify-content-between a-apply-dark-theme-color`}>
                        <div className="a-brand-container a-white">
                            <Link className={'flex text-decoration-none'} to={HOME_URL}>
                                <div className="a-logo flex-center flex-middle" style={{ flexShrink: 0 }}>
                                    <img src={process.env.PUBLIC_URL + '/logo.png'} width="40" height="15" alt="LOGO" />
                                </div>
                                <span className="font-weight-medium text-nowrap a-white">{t('common.pageTitle')}</span>
                            </Link>
                            <div className="a-divider-full" />
                            {this.menuList.map((x) => {
                                return (
                                    x.name && (
                                        <NavLink
                                            to={x.path}
                                            key={x.path}
                                            className="a-navLink flex-center flex-middle"
                                            activeClassName="a-activited"
                                        >
                                            {x.name}
                                        </NavLink>
                                    )
                                )
                            })}
                        </div>
                        <div className="a-actions-container">
                            <Switch
                                fontColor="var(--iba-white)"
                                label={t('common.userMode')}
                                onChange={this.handleClickToV2}
                            />
                            <div className={styles.help_menu}>
                                <HelpMenu t={t} />
                            </div>
                            <LanguageSelect className="langSelect" />
                            <Tooltip content={this.LogoutTooltip()} trigger="click" position={'bottom-left'} isDark>
                                <div>
                                    <Avatar className={styles.avatar} label={avatarLabel} />
                                </div>
                            </Tooltip>
                        </div>
                    </nav>
                </div>
            </>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        userInfo: state.userInfo.userinfo,
        contract: state.userInfo.contractplan
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        updateUser: bindActionCreators(updateUser, dispatch),
        clearFilter: bindActionCreators(clearFilter, dispatch),
        clearSimulationFilter: bindActionCreators(clearSimulationFilter, dispatch)
    }
}

export const Header = withRouter(withTranslation()(connect(mapStateToProps, mapDispatchToProps)(Head)))
